import React from 'react';
import './loading.css';
function LoadingHead() {
    return (
        <div className="loading-spinner">
            <img
                src="/image/chillhead.png"
                alt="Chill head"
            />
        </div>
    );
}

export default LoadingHead;
